import { render, staticRenderFns } from "./VisitCreate.vue?vue&type=template&id=6fd9d162&scoped=true"
import script from "./VisitCreate.vue?vue&type=script&lang=js"
export * from "./VisitCreate.vue?vue&type=script&lang=js"
import style0 from "./VisitCreate.vue?vue&type=style&index=0&id=6fd9d162&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd9d162",
  null
  
)

export default component.exports